import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RideBookingService } from 'src/app/services/ride-booking.service';
import { AuthService } from 'src/app/services/auth.service';
import { ViewRideBookingModel } from 'src/app/models/booking';

@Injectable({
    providedIn: 'root'
})
export class CreateReviewResolver implements Resolve<ViewRideBookingModel | null> {
    constructor(
        private rideBookingService: RideBookingService,
        private authService: AuthService,
        private router: Router
    ) {}

    resolve(route: ActivatedRouteSnapshot): Observable<ViewRideBookingModel | null> {
        const bookingId = route.paramMap.get('rbId');
        const reviewedPersonId = route.paramMap.get('pId');
        if (!bookingId || !reviewedPersonId) {
            this.router.navigate(['/404']);
            return of(null);
        }

        return this.rideBookingService.getBooking(bookingId).pipe(
            map(booking => {
                const currentUserId = this.authService.user$.value.user?.id;

                // Can't review yourself
                if (reviewedPersonId == currentUserId) {
                    this.router.navigate(['/404']);
                    return null;
                }

                // Can only review if you are the traveller or the driver
                if (booking.travellerUserId !== currentUserId && booking.driverId !== currentUserId) {
                    this.router.navigate(['/404']);
                    return null;
                }
                return booking;
            }),
            catchError(() => {
                this.router.navigate(['/404']);
                return of(null);
            })
        );
    }
}